import {IPatch} from "../interfaces/requests";
import {api} from "../../../helpers";

export const axiosPatch = <Model>({url, data}: IPatch<Model>) => {
  return api.patch(url, data);
};
